module.exports = __webpack_public_path__ + "static/media/slide.25167a53.svg";